{
  "collapse": "折りたたむ",
  "expand": "展開"
}
